import noop from 'lodash/noop'
import { OrderItemClient } from 'schema'

import { OrderCreateContextType } from './types'

export const DEBOUNCE_DELAY = 500

export const orderCreateContextInitial: OrderCreateContextType = {
  activeCustomerId: undefined,
  setActiveCustomerId: noop,
  activeCustomer: undefined,
  setActiveCustomer: noop,
  selectedCustomer: undefined,
  setSelectedCustomer: noop,
  isContactsByCustomerList: false,
  setIsContactsByCustomerList: noop,
  isActiveCustomerAddContactAccess: false,
  setIsActiveCustomerAddContactAccess: noop,
  isShowAttachBtn: false,
  setIsShowAttachBtn: noop,
  isAttachBlockFullHeight: false,
  setIsAttachBlockFullHeight: noop,
  getCustomerContact: () => ({
    contact: {
      firstname: '',
      lastname: '',
      secondname: '',
      phone: '',
      phoneExt: ''
    },
    type: OrderItemClient.type.LEGAL
  }),
  getPartnerContact: () => ({
    contact: {
      firstname: '',
      lastname: '',
      secondname: '',
      phone: '',
      phoneExt: ''
    },
    type: OrderItemClient.type.LEGAL
  })
}
